import { render, staticRenderFns } from "./JobAiCallingTab.vue?vue&type=template&id=f53f7850&scoped=true&"
import script from "./JobAiCallingTab.vue?vue&type=script&lang=js&"
export * from "./JobAiCallingTab.vue?vue&type=script&lang=js&"
import style0 from "./JobAiCallingTab.vue?vue&type=style&index=0&id=f53f7850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53f7850",
  null
  
)

export default component.exports